import baseApi from "./baseApi";
import apiPaths from "./apiPaths";

export class reportResultsApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async GetPlaylistForTeamMetric(userId: string, reportId: string, matchId: string, teamId: string, metricId: string, clipName: string) {
        return await this.Get(apiPaths.getPlaylistForTeamMetric(userId, reportId, matchId, teamId, metricId, clipName));
    }

    public async GetPlaylistForPlayerMetric(userId: string, reportId: string, matchId: string, teamId: string, metricId: string, clipName: string, playerId: string) {
        return await this.Get(apiPaths.getPlaylistForPlayerMetric(userId, reportId, matchId, teamId, metricId, clipName, playerId));
    }
}